var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1593(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3499 15.3508L45.3803 15.3242C45.1903 15.3356 45.0002 15.3572 44.8215 15.3838C44.6809 15.4028 44.539 15.4281 44.4009 15.456C43.9721 15.5404 43.5512 15.6608 43.1426 15.8159C42.0633 16.223 41.0869 16.8628 40.2827 17.6899C40.2612 17.8521 40.2447 18.0156 40.2295 18.1803C40.0913 19.6616 40.1659 21.1551 40.4513 22.6152C40.7097 24.2451 41.3295 25.7966 42.2652 27.156C43.201 28.5153 44.429 29.6481 45.8593 30.4713H45.8897L46.0798 30.4117C44.0781 28.4675 42.8882 25.8364 42.7501 23.0493C42.6121 20.2622 43.5362 17.5265 45.336 15.3939C45.336 15.3784 45.3409 15.3634 45.3499 15.3508Z",
    fill: "url(#paint0_linear_2879_7130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7232 11.2714C35.6903 11.5172 35.6624 11.7655 35.6396 12.0126C35.2714 15.8936 36.0285 19.7986 37.8203 23.2608C37.8761 23.3698 37.9343 23.4749 37.9914 23.5814C38.1417 23.861 38.2976 24.136 38.4589 24.4063C39.9927 26.9745 42.0763 29.1711 44.5601 30.8381C44.6158 30.8762 44.6665 30.9142 44.7223 30.9509L44.7856 30.9889L44.8072 30.9674L44.8743 30.9028C44.9123 30.8698 44.9503 30.8419 44.9909 30.8128C45.1664 30.7087 45.3547 30.6278 45.551 30.5721C44.0714 29.7562 42.7971 28.614 41.8249 27.2322C40.8527 25.8503 40.2082 24.265 39.9402 22.5968C39.7092 21.4039 39.6169 20.1883 39.6652 18.9742C39.6652 18.7727 39.6842 18.5699 39.702 18.3697C39.8726 16.275 40.4638 14.2363 41.4402 12.3752C42.4167 10.5142 43.7583 8.86918 45.385 7.53845C45.295 7.52832 45.1949 7.52325 45.1138 7.51691C44.9326 7.50298 44.7539 7.49157 44.5727 7.48777C43.7351 7.46751 42.8977 7.53803 42.0753 7.69811C39.626 8.16773 37.3963 9.42203 35.7232 11.2714Z",
    fill: "url(#paint1_linear_2879_7130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3205 22.6307C33.6584 23.1375 34.0213 23.6313 34.409 24.1119L34.6345 24.392C36.7079 26.938 39.2828 29.0303 42.1992 30.5387L42.4412 30.6655C43.0908 30.9907 43.7518 31.2863 44.4243 31.5524C44.4567 31.4779 44.4931 31.4052 44.5332 31.3345L44.4965 31.3117C44.3989 31.2509 44.3064 31.185 44.205 31.1216C44.0416 31.0152 43.8794 30.9024 43.7185 30.7922H43.7071C41.8208 29.4753 40.1724 27.8471 38.8325 25.9771C38.5981 25.649 38.3725 25.3094 38.1533 24.9634C37.8403 24.4642 37.5438 23.9498 37.2663 23.415C35.5882 20.1673 34.8181 16.5268 35.0375 12.8777C35.0565 12.5901 35.078 12.3062 35.1059 12.0161C35.4563 8.61127 36.6538 5.34844 38.5892 2.52539C38.242 2.59128 37.8965 2.67026 37.5527 2.76234C34.1928 3.65241 31.2419 5.6722 29.1961 8.48209C29.0467 13.5149 30.4901 18.4665 33.3205 22.6307Z",
    fill: "url(#paint2_linear_2879_7130)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.551 26.6612C35.1338 29.5095 39.372 31.4165 43.88 32.2086L44.2019 32.2606L44.2247 32.1465C44.2348 32.1098 44.2424 32.0743 44.2513 32.0376C40.5465 30.6644 37.2402 28.3934 34.6288 25.4283C34.4219 25.196 34.2191 24.9578 34.0206 24.7136C31.2708 21.3447 29.4844 17.294 28.8513 12.9916C28.2182 8.68921 28.7618 4.29566 30.4245 0.277344C30.0436 0.437845 29.6634 0.612706 29.2841 0.801929C25.5653 2.68533 22.6228 5.81073 20.9668 9.63625C21.9177 14.4274 24.088 18.8925 27.2682 22.6001C28.5531 24.0953 29.9887 25.4541 31.5523 26.6549L31.551 26.6612Z",
    fill: "url(#paint3_linear_2879_7130)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0295 28.524C25.2219 29.2925 26.4643 29.9804 27.7485 30.5831C32.591 32.861 37.9407 33.8462 43.277 33.4429C43.5748 33.4201 43.8713 33.391 44.164 33.3606C44.164 33.2744 44.1538 33.1895 44.1488 33.1072V32.7853C43.4519 32.6822 42.7579 32.5555 42.0669 32.4052C38.0255 31.5005 34.2314 29.7212 30.9518 27.1923C30.0651 26.5115 29.2189 25.7796 28.4175 25.0002C24.4596 21.1499 21.7112 16.2283 20.5095 10.8389C19.7108 7.2798 19.5994 3.60089 20.1813 0C19.7834 0.290169 19.3919 0.594276 19.013 0.914856C15.2334 4.09242 12.6875 8.49461 11.8184 13.3554C14.1501 19.5944 18.4326 24.9133 24.0295 28.524Z",
    fill: "url(#paint4_linear_2879_7130)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2119 35.9359C25.482 36.4192 27.7967 36.6621 30.1177 36.6607C34.4297 36.666 38.6999 35.8159 42.6811 34.1594C41.8516 34.2203 41.0191 34.2477 40.1836 34.2418C35.7001 34.209 31.2771 33.2039 27.2198 31.2958L26.9752 31.1779C19.9886 27.84 14.5032 22.0093 11.5975 14.8322C10.3061 11.65 9.54673 8.27713 9.34969 4.84856V4.81055C8.9911 5.21476 8.64644 5.63037 8.31699 6.06119C6.44568 8.49689 5.0798 11.2819 4.29951 14.2527C3.51922 17.2235 3.34026 20.3202 3.77312 23.3611C8.4932 29.7928 15.4105 34.2675 23.2119 35.9359Z",
    fill: "url(#paint5_linear_2879_7130)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5875 37.8107C45.1009 37.8107 44.7828 37.4927 44.6346 36.8667C44.4838 36.2028 44.3812 35.5173 44.3127 34.9331C44.3093 34.8736 44.3021 34.8143 44.2912 34.7557L44.2684 34.5517L44.2393 34.2806L44.2266 34.1082C39.7438 36.3098 34.8149 37.4513 29.8208 37.4445C28.7876 37.4445 27.7672 37.3976 26.7594 37.3039C18.5302 36.5336 10.8981 32.6754 5.3984 26.5055C4.92957 25.9759 4.47848 25.4306 4.04513 24.8697C4.04597 24.8781 4.04597 24.8866 4.04513 24.895C2.88825 23.4196 1.86062 21.8472 0.973642 20.1953C0.811451 20.7389 0.687274 21.3091 0.565631 21.8654C-0.705511 27.6404 0.182446 33.6811 3.06174 38.846C5.94104 44.011 10.6123 47.9425 16.1929 49.898C21.7735 51.8534 27.8771 51.6972 33.3504 49.4589C38.8237 47.2207 43.2878 43.0554 45.8992 37.7499C45.7998 37.7849 45.6953 37.8029 45.59 37.8031L45.5875 37.8107Z",
    fill: "url(#paint6_linear_2879_7130)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2714 42.0931C37.6991 42.0934 36.1619 41.6273 34.8544 40.7539C33.5469 39.8805 32.5277 38.639 31.9258 37.1864C31.3239 35.7338 31.1663 34.1353 31.4729 32.5931C31.7795 31.0509 32.5366 29.6342 33.6483 28.5223C34.7601 27.4103 36.1766 26.6531 37.7188 26.3462C39.2609 26.0394 40.8595 26.1967 42.3122 26.7984C43.7649 27.4001 45.0066 28.419 45.8802 29.7264C46.7538 31.0338 47.2201 32.5709 47.2201 34.1432C47.2201 36.2515 46.3827 38.2733 44.892 39.7642C43.4014 41.255 41.3797 42.0928 39.2714 42.0931Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2804 41.4162C43.298 41.4162 46.5549 38.1593 46.5549 34.1417C46.5549 30.1241 43.298 26.8672 39.2804 26.8672C35.2628 26.8672 32.0059 30.1241 32.0059 34.1417C32.0059 38.1593 35.2628 41.4162 39.2804 41.4162Z",
    fill: "#901F5D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2525 33.6366L38.0802 29.692C37.985 29.6197 37.8715 29.5752 37.7525 29.5636C37.6335 29.552 37.5136 29.5737 37.4062 29.6262C37.2989 29.6788 37.2082 29.7602 37.1444 29.8613C37.0806 29.9625 37.0461 30.0793 37.0449 30.1989V38.0892C37.0461 38.2088 37.0806 38.3256 37.1444 38.4268C37.2082 38.5279 37.2989 38.6093 37.4062 38.6619C37.5136 38.7144 37.6335 38.7361 37.7525 38.7245C37.8715 38.7129 37.985 38.6684 38.0802 38.5961L43.2525 34.6515C43.3311 34.5913 43.3947 34.5138 43.4386 34.425C43.4824 34.3363 43.5052 34.2386 43.5052 34.1396C43.5052 34.0406 43.4824 33.943 43.4386 33.8542C43.3947 33.7654 43.3311 33.6879 43.2525 33.6277V33.6366Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2879_7130",
    x1: 44.6181,
    y1: 11.4466,
    x2: 36.3408,
    y2: 22.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2879_7130",
    x1: 40.3599,
    y1: 5.83906,
    x2: 43.0379,
    y2: 29.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2879_7130",
    x1: 38.21,
    y1: -0.754665,
    x2: 31.1258,
    y2: 29.6858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2879_7130",
    x1: 31.4914,
    y1: 2.67609,
    x2: 35.1147,
    y2: 33.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2879_7130",
    x1: 21.328,
    y1: 6.03559,
    x2: 35.019,
    y2: 38.7213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2879_7130",
    x1: 15.6758,
    y1: 15.2574,
    x2: 25.307,
    y2: 41.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2879_7130",
    x1: 12.0256,
    y1: 20.5681,
    x2: 22.4287,
    y2: 51.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4352",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DC3C54",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B22C58",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#98225A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F1E5B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1593);
export default __webpack_public_path__ + "static/media/Group 1593.73fe500a.svg";
export { ForwardRef as ReactComponent };